module.exports = __webpack_public_path__ + "static/media/campaignEmpty.f612d830.svg";